import React from 'react';
import Image from 'next/image';
import { FallbackLogoSVG } from '@benzinga/search-ui';

interface CompanyLogoProps {
  logo: string;
  name: string;
  symbol?: string;
  wrapperClassName?: string;
}

const logoFrameClassName =
  'company-logo flex h-16 w-16 shrink-0 items-center justify-center rounded border border-[#d4dbe7] bg-white p-1';

export const CompanyLogo: React.FC<CompanyLogoProps> = ({ logo, name, symbol, wrapperClassName }) => {
  const frameClassName = [logoFrameClassName, wrapperClassName].filter(Boolean).join(' ');
  if (!logo || !logo.trim()) {
    const letter = (symbol || name).trim().charAt(0).toUpperCase() || '?';
    return (
      <div className={frameClassName}>
        <FallbackLogoSVG letter={letter} size={50} />
      </div>
    );
  }

  return (
    <div className={frameClassName}>
      <Image alt={name} height={50} priority src={logo} width={50} />
    </div>
  );
};
